import axios from "@/services/axios";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
const ls = new SecureLS({ isCompression: false });

export default {
    plugins: [
        createPersistedState({
            storage: {
                getItem: (key) => ls.get(key),
                setItem: (key, value) => ls.set(key, value),
                removeItem: (key) => ls.remove(key),
            },
        }),
    ],

    namespaced: true,

    state: {
        lojas: Array,
        pessoa: Object,
        emailInvalido: Boolean,
        enderecoInvalido: Boolean,
        telefoneInvalido: Boolean,
        dadosCadastraisConfirmados: false,
        mostrarFormularioDadosCadastrais: false,
    },

    mutations: {
        SET_LOJAS(estado, lojas) {
            estado.lojas = lojas;
        },
        SET_PESSOA(estado, pessoa) {
            estado.pessoa = pessoa;
        },
        SET_EMAIL_INVALIDO(estado, emailInvalido) {
            estado.emailInvalido = emailInvalido;
        },
        SET_TELEFONE_INVALIDO(estado, telefoneInvalido) {
            estado.telefoneInvalido = telefoneInvalido;
        },
        SET_ENDERECO_INVALIDO(estado, enderecoInvalido) {
            estado.enderecoInvalido = enderecoInvalido;
        },
        SET_DADOS_CADASTRAIS_CONFIRMADOS(estado, dadosCadastraisConfirmados) {
            estado.dadosCadastraisConfirmados = dadosCadastraisConfirmados;
        },
        SET_MOSTRAR_FORMULARIO_DADOS_CADASTRAIS(estado, mostrarFormularioDadosCadastrais) {
            estado.mostrarFormularioDadosCadastrais = mostrarFormularioDadosCadastrais;
        }
    },

    getters: {
        getPesCpf(estado) {
            return estado.pessoa.pesCpfCnpj;
        },
        getEnderecoInvalido(estado) {
            return estado.enderecoInvalido;
        },
        getTelefoneInvalido(estado) {
            return estado.telefoneInvalido;
        },
        getEmailInvalido(estado) {
            return estado.emailInvalido;
        },
        getPesCodigo(estado) {
            return estado.pessoa.pesCodigo;
        },
        getDadosCadastraisConfirmados(estado) {
            return estado.dadosCadastraisConfirmados;
        },
        getMostrarFormularioDadosCadastrais(estado) {
            return estado.mostrarFormularioDadosCadastrais;
        },
        getPessoa(estado) {
            return estado.pessoa;
        },
    },

    actions: {
        async acaoPasso1ConsultarCpf(contexto, dados) {
            return await axios({
                method: "POST",

                url: "api.php",

                params: {
                    a: "negociacao",
                    b: "passo_1",
                    token: "c59509089cf6afeb39d2d0b1124ee6d9"
                },

                data: {
                    pes_cpf_cnpj: dados.pesCpfCnpj
                }

            }).then(resposta => {
                let dados;
                if (resposta.data.dados) {
                    dados = resposta.data.dados;

                } else {
                    return resposta;
                }

                contexto.commit("SET_PESSOA", {
                    pesCodigo: dados.pes_codigo,
                    pesNome: dados.pes_nome,
                    pesCpfCnpj: dados.pes_cpf_cnpj,
                    pesEmail: dados.pes_email,
                    pefFone: dados.pef_fone,
                    pessoaEndereco: dados.pessoa_endereco,
                });

                contexto.commit("SET_LOJAS", dados.lojas);

                return resposta;
            });
        },

        async acaoPasso2ConsultarDividas(contexto, dados) {
            return await axios({
                method: "POST",

                url: "api.php",

                params: {
                    a: "negociacao",
                    b: "passo_2_novo",
                    token: "c59509089cf6afeb39d2d0b1124ee6d9"
                },

                data: {
                    pes_codigo: contexto.state.pessoa.pesCodigo,
                    loj_codigo: dados.lojCodigo,
                    lancamento_futuro: 'N'
                }

            }).then(resposta => {
                return resposta.data;
            });
        },

        async acaoPasso3ConsultarNegociacoes(contexto, dados) {
            return await axios({
                method: "POST",

                url: "api.php",

                params: {
                    a: "negociacao",
                    b: "passo_3_novo",
                    token: "c59509089cf6afeb39d2d0b1124ee6d9"
                },

                data: {
                    pes_codigo: contexto.state.pessoa.pesCodigo,
                    loj_codigo: dados.lojCodigo,
                    pre_codigo: dados.preCodigo,
                    primeiro_vencimento: dados.primeiroVencimento,
                    pagamento_avista_prazo: dados.pagamentoAvistaPrazo,
                    juros_parcelamento: dados.jurosParcelamento,
                    forma_pagamento: dados.formaPagamento,
                }

            }).then(resposta => {
                if (resposta.data) {
                    return resposta.data;
                }
            });
        },

        async acaoPasso4GravarAcordo(contexto, dados) {
            return await axios({
                method: "POST",

                url: "api.php",

                params: {
                    a: "negociacao",
                    b: "passo_4_novo",
                    token: "c59509089cf6afeb39d2d0b1124ee6d9"
                },

                data: {
                    pra_codigo: dados.praCodigo,
                    forma_pagamento: dados.formaDePagamento,
                    dados_do_cartao: [],
                    primeiro_vencimento: dados.primeiroVencimento,
                    gerar_boleto: 1,
                    pagamento_avista_prazo: dados.pagamentoAvistaPrazo
                }

            }).then(resposta => {
                if (resposta.data) {
                    return resposta.data;
                }
            });
        },

        async acaoPasso5RetornarAcordo(contexto, dados) {
            return await axios({
                method: "POST",

                url: "api.php",

                params: {
                    a: "negociacao",
                    b: "passo_5",
                    token: "c59509089cf6afeb39d2d0b1124ee6d9"
                },

                data: {
                    pes_codigo: contexto.state.pessoa.pesCodigo,
                    loj_codigo: dados.lojCodigo
                }

            }).then(resposta => {
                if (resposta.data) {
                    return resposta.data;
                }
            });
        }
    }
}